// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__kb_7W","cell":"ColumnAccessor_cell__2lJwm","firstCellAccent":"ColumnAccessor_firstCellAccent__1GYhB"};